/**
 * Период сборки: значение по умолчанию и разбор набранного руками.
 *
 * Поля формы текстовые и показывают привычные ДД.ММ.ГГГГ, а
 * `createProjectReport` принимает скаляр `Date`, то есть ISO. Перевод и
 * проверка календаря живут здесь — страница календарём не занимается.
 *
 * @format
 */

const RU_DATE = /^(\d{2})\.(\d{2})\.(\d{4})$/;

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

function ru(date: Date): string {
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
}

/**
 * Прошлый закрытый месяц относительно `today`.
 *
 * Отчёт собирают по завершившемуся периоду, поэтому текущий месяц в
 * умолчание не годится. Дата передаётся аргументом, а не берётся изнутри:
 * иначе значение нельзя проверить тестом.
 */
export function lastClosedMonth(today: Date): {from: string; to: string} {
  const year = today.getFullYear();
  const month = today.getMonth();

  // Нулевой день следующего месяца — последний день предыдущего; так длина
  // февраля считается сама, без таблицы и без правила високосного года.
  return {
    from: ru(new Date(year, month - 1, 1)),
    to: ru(new Date(year, month, 0)),
  };
}

/**
 * `ДД.ММ.ГГГГ` → ISO `ГГГГ-ММ-ДД`. `null`, если это не дата.
 *
 * Проверяется и календарь: `31.02.2026` соответствует форме записи, но такого
 * дня не существует, и отправлять его на сервер незачем.
 */
export function parseRuDate(value: string): string | null {
  const match = RU_DATE.exec(value.trim());
  if (!match) return null;

  const [, day, month, year] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));

  const real =
    date.getFullYear() === Number(year) &&
    date.getMonth() === Number(month) - 1 &&
    date.getDate() === Number(day);

  return real ? `${year}-${month}-${day}` : null;
}
